/* Gospel Archive — product media gallery: keyboard/touch-swipeable, syncs with
   the variant picker's media-change event, thumbnail tablist semantics. */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var current = 0;

    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.hidden = i !== current; });
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-selected', i === current ? 'true' : 'false'); });
    }

    function showByMediaId(mediaId) {
      var index = slides.findIndex(function (slide) { return slide.dataset.mediaId === String(mediaId); });
      if (index > -1) show(index);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(current + 1);
      if (e.key === 'ArrowLeft') show(current - 1);
    });

    // Basic touch swipe
    var touchStartX = null;
    var main = gallery.querySelector('[data-gallery-main]');
    if (main) {
      main.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (touchStartX == null) return;
        var delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 40) show(delta > 0 ? current - 1 : current + 1);
        touchStartX = null;
      });
    }

    document.addEventListener('ga:variant-media-change', function (e) {
      showByMediaId(e.detail.mediaId);
    });
  });
})();
